/* eslint-disable @typescript-eslint/consistent-type-assertions */
import * as React from 'react';

import { Styled } from './meta.styles';
import type { MetaProps } from './meta.types';

export const Meta = React.forwardRef<HTMLParagraphElement, MetaProps>(
  (
    {
      children,
      className,
      ellipsis,
      fontWeight = 'regular',
      lineHeight,
      noMargin,
      size,
      sizeConfined,
      sizeWide,
      ...props
    },
    forwardedRef
  ) => {
    const fullText = typeof children === 'string' ? children : undefined;

    return (
      <Styled.Meta
        className={className}
        data-xds="Meta"
        ellipsis={ellipsis}
        fontWeight={fontWeight}
        lineHeight={lineHeight}
        noMargin={noMargin}
        ref={forwardedRef}
        size={size}
        sizeConfined={sizeConfined}
        sizeWide={sizeWide}
        title={ellipsis && fullText ? fullText : undefined}
        {...props}
      >
        {children}
      </Styled.Meta>
    );
  }
);

Meta.displayName = 'Meta';

export const InlineMeta = React.forwardRef<HTMLSpanElement, MetaProps>(
  (props, ref) => (
    <Meta as="span" {...props} ref={ref as React.Ref<HTMLParagraphElement>} />
  )
);

InlineMeta.displayName = 'InlineMeta';
